/*
 * @FilePath: \kitchen-online-web\src\apis\homePage.js
 * @Author: Xiaohua Zhu
 * @Date: 2021-12-30 11:21:31
 * @LastEditors: Xiaohua Zhu
 * @LastEditTime: 2021-12-30 14:38:03
 * @Description: Description
 */
import request from '@/utils/request';

export function getWallList() { // 墙面列表
  return request({
    url: '/component/wall/list',
    method: 'GET',
  });
}

export function getFloorList() { // 地面列表
  return request({
    url: '/component/floor/list',
    method: 'GET',
  });
}

export function updateFloor(data) { // 替换地面
  return request({
    url: '/component/replaceFloor/update',
    method: 'PUT',
    data,
  });
}

export function updateWall(data) { // 替换墙面
  return request({
    url: '/component/replaceWall/update',
    method: 'PUT',
    data,
  });
}

